import { render, staticRenderFns } from "./SlidePackage.vue?vue&type=template&id=5874b0e2&scoped=true&"
var script = {}
import style0 from "./SlidePackage.vue?vue&type=style&index=0&id=5874b0e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5874b0e2",
  null
  
)

export default component.exports